package com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components

import app.tulz.diff.DiffElement.{Diff, InBoth, InFirst, InSecond}
import com.neurobs.ccabserver.transcriptreview.states.{CommandRouterContext, TestTranscriptReviewStateGenerator, VisibilityStateGenerator}
import com.neurobs.ccabserver.transcriptreview.util.{EditableTranscript, NonEditableTranscript}
import com.neurobs.react.StyleUtil
import com.neurobs.util.Interval
import com.neurobs.util.TimeSeconds
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useState
import slinky.core.facade.ReactElement
import slinky.web.html._
import app.tulz.diff.SeqDiff

import scala.collection.mutable.ArrayBuffer

case class TranscriptWordIndex
(
	recordingIndex: Int,
	wordIndex: Int
)

@react
object TranscriptText {

	case class Props()

	/** Generates a Seq that indicates if the words (in order) in reviewing have "changed"
	 * relative to the words in reference.
	 *
	 * @param reviewing Transcript that is being edited
	 * @param reference Reference relative to which changes are generated
	 * @return Same size Seq as reviewing indicating what words have changed
	 */
	def generatedChangedStatus(reviewing: EditableTranscript, reference: NonEditableTranscript): Seq[Boolean] = {
		val reviewingWords = reviewing.transcriptWords.map(_.word).toIndexedSeq
		val referenceWords = reference.transcriptWords.map(_.word).toIndexedSeq
		val diff = SeqDiff.seq(reviewingWords, referenceWords)
		val res = ArrayBuffer[Boolean]()
		diff foreach {
			case InBoth(v) => for (_ <- v) res += false
			case InFirst(v) => for (_ <- v) res += true
			case Diff(x, _) => for (_ <- x) res += true
			case InSecond(_) =>
		}
		// If the diff code is right, res should be the same size as reviewingWords, but
		// just in case, bail with the correct size
		if (res.size == reviewingWords.size) res.toVector
		else Seq.fill(reviewingWords.size)(false)
	}

	val component = FunctionalComponent[Props] { props =>

		val (highlightedWord, setHighlightedWord) = useState[Option[TranscriptWordIndex]](None)

		val visibilityState = VisibilityStateGenerator.accessState
		val testState = TestTranscriptReviewStateGenerator.accessState

		val commandRouter = CommandRouterContext.accessState
		commandRouter.setTranscriptTextHighlightedWord = word => setHighlightedWord(word)

		val temp = new ArrayBuffer[ReactElement]()
		var notFirst = false
		for ((r, recordingIndex) <- testState.handler.value.recordings.view.zipWithIndex) {
			if (notFirst) {
				temp += " \u25C9 "
			}
			notFirst = true
			val wordChanged = generatedChangedStatus(r.reviewingTranscript, r.casrTranscript)
			for ((w, wordIndex) <- r.reviewingTranscript.transcriptWords.view.zipWithIndex) {
				val highlighted = highlightedWord.exists(w => w.recordingIndex == recordingIndex && w.wordIndex == wordIndex)
				val cname =
					if (wordChanged(wordIndex)) {
						if (highlighted) "highlighted-transcript-text-link-changed" else "transcript-text-link-changed"
					}
					else {
						if (highlighted) "highlighted-transcript-text-link" else "transcript-text-link"
					}
				temp += a(
					className := cname,
					onClick := {() => {
					testState.selectWord(recordingIndex = recordingIndex, transcriptInterval = Interval[TimeSeconds](w.startTime, w.endTime))
					}},
					w.word
				)
				temp += " "
			}
		}

		if (visibilityState.transcriptTextIsVisible) {
			div(className := "ui center aligned segment black-text",
				style := StyleUtil.makeStyle(("marginLeft", "30px"), ("marginRight", "30px"))
			)(
			h4("Reviewed Transcript Text"),
			div(className := "ui divider"),
				temp
			)
		}
		else null
	}
}
